import React from 'react';
import DevelopmentProjectCard from '../components/property/DevelopmentProjectCard'; // Corrected import path
import { mockDevelopmentProjects, DevelopmentProjectType } from '../utils/mockData';
import { Container, Grid, Typography, Box } from '@mui/material';

const DevelopmentProjectsPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight={700}>
          Development Projects
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Explore our latest and upcoming development projects.
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {mockDevelopmentProjects.map((project: DevelopmentProjectType) => (
          <Grid item xs={12} sm={6} md={4} key={project.id}>
            <DevelopmentProjectCard project={project} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default DevelopmentProjectsPage;
